import InfoIconBlock from '../InfoIconBlock'

const InfoIconBlockNoRoutes = (props) => {
  return (
    <InfoIconBlock
      {...props}
      info_msg="Наразі немає доступних маршрутів для цього виду транспорту."
      withBg
    />
  )
}

export default InfoIconBlockNoRoutes
